import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type React from 'react';
type SubsectionProps = {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
};
const Subsection = t0 => {
  const $ = _c(6);
  const {
    children,
    className,
    padding: t1
  } = t0;
  const padding = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== className || $[1] !== padding) {
    t2 = cx("flex flex-col gap-2", {
      "p-5": padding
    }, className);
    $[0] = className;
    $[1] = padding;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default Subsection;